import RefreshIcon from '@/assets/icons/Refresh';
import { Form } from '@/components/ui/form';
import { cn } from '@/lib/utils.ts';
import { Search } from 'lucide-react';
import { FC, Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { InputControl } from '@/components/controls/input-control';
import SelectControl from '@/components/controls/select-control';
import { Button } from '@/components/ui/button';
import useAgrotechFilter from '../hooks/useAgrotechFilter';

interface IFilterProps {
  page: string;
  className: string;
}

const AgrotechFilter: FC<IFilterProps> = ({ page, className }) => {
  const { t } = useTranslation();
  const {
    user,
    form,
    control,
    regionList,
    districtList,
    handleForm,
    clearFilter,
    selectFormat,
    plantsList,
  } = useAgrotechFilter({ page });
  const [size, setSize] = useState({
    width: window.innerWidth,
  });
  useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
      });
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Fragment>
      <Form {...form}>
        <form onSubmit={handleForm} className={cn('', className)}>
          <div className="flex items-end justify-between gap-3">
            <div className="flex justify-between w-full">
              <div className="flex items-center gap-3">
                <InputControl
                  control={form.control}
                  labelClass={'text-xs'}
                  name="inn"
                  inputClass="h-8"
                  label={t('inn')}
                  className="min-w-[140px] w-[200px]"
                  type="number"
                  maxLength={9}
                  withoutDescription
                />
              </div>
              <div className="flex items-end justify-between space-x-4 ml-2">
                <div className="flex gap-4">
                  <Button
                    type="submit"
                    variant="outline"
                    className={cn(
                      'p-[10px] active:translate-y-[1px] duration-200',
                    )}
                  >
                    <Search className="stroke-cyan-default" />
                  </Button>
                  <Button
                    type="button"
                    onClick={() => clearFilter()}
                    variant="outline"
                    className=" p-[10px] active:translate-y-[1px] duration-200"
                  >
                    <RefreshIcon />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Form>
    </Fragment>
  );
};

export default AgrotechFilter;
